module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/remi/Documents/metabase/metabase-0.28.1/node_modules/babel-loader/lib/index.js??ref--0-0!/Users/remi/Documents/metabase/metabase-0.28.1/node_modules/eslint-loader/index.js!/Users/remi/Documents/metabase/metabase-0.28.1/frontend/src/platopulse/lib/ga-metadata.js"));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// /Users/remi/Documents/metabase/metabase-0.28.1/node_modules/promise-loader?global!./lib/ga-metadata.js
// module id = 365
// module chunks = 3 4 5